import { Button } from '@mui/material';
import { ArrowRightOutlined } from '@ant-design/icons';
import { inkButtonSx } from '../../../../get-started/inkButtonSx';
import { TOUR_ANCHOR } from '../../../../welcome-tour/tourAnchors';

type Props = { label: string; disabled?: boolean; onClick: () => void };

// Shared Configure-step CTA (trading + Signal Manager branches).
export function ProceedButton({ label, disabled, onClick }: Props) {
  return (
    <Button
      data-tour={TOUR_ANCHOR.CHECKOUT_PROCEED}
      variant="contained"
      size="large"
      endIcon={<ArrowRightOutlined />}
      onClick={onClick}
      disabled={disabled}
      sx={(theme) => ({
        height: 48,
        fontSize: 14,
        ...inkButtonSx(theme.palette.mode === 'dark')
      })}
    >
      {label}
    </Button>
  );
}
